<template>
    <span class="text-nowrap text-right" :class="{'text-danger':row.TICKETExceedAmount}">
        <template v-if="row.TICKETExceedAmount">
            <feather-icon icon="AlertOctagonIcon" class="text-danger mr-auto" v-b-tooltip.noninteractive.hover.bottom :title="`Ticket üst limiti ${row.TICKETExceedAmountStr} tutar kadar aşıldı.`"></feather-icon>
        </template>
        {{row.TICKETStr || '-'}} 
    </span>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';

export  default {
    props:{
        row:Object,
        field:Object,
    },
    directives:{
        'b-tooltip':VBTooltip
    }
}
</script>